import { render, staticRenderFns } from "./nodeTable.vue?vue&type=template&id=546a5992&scoped=true"
import script from "./nodeTable.vue?vue&type=script&lang=js"
export * from "./nodeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546a5992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('546a5992')) {
      api.createRecord('546a5992', component.options)
    } else {
      api.reload('546a5992', component.options)
    }
    module.hot.accept("./nodeTable.vue?vue&type=template&id=546a5992&scoped=true", function () {
      api.rerender('546a5992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compensationManagement/compensationList/components/nodeTable.vue"
export default component.exports